import IframeActivity from "./IframeActivity";

export default function ListeningForWhatMatters() {
    return (
        <IframeActivity
            src="/activities/listening-for-what-matters/index.html"
            title="The Important Part"
        />
    );
}